import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AnimatedGroup from './AnimatedGroup';
import { ThemeContext } from '../utils/context';

function ServiceCard({
  children,
  className = '',
  preset = 'blur-slide',
  inViewOnce = false,
  inViewAmount = 0.5,
  rootMargin = '0px 0px -10% 0px',
}) {
  const { theme } = useContext(ThemeContext);

  const base = 'p-3 md:p-4 rounded-2xl flex flex-col items-center justify-center border transition-all duration-500 cursor-pointer';
  const byTheme = theme === 'light'
    ? 'border-gray-300 hover:shadow-gray-400'
    : 'border-neutral-600 hover:shadow-neutral-700';
  const hover = 'hover:shadow-md';

  return (
    <AnimatedGroup
      className="w-full"
      preset={preset}
      inViewOnce={inViewOnce}
      inViewAmount={inViewAmount}
      rootMargin={rootMargin}
    >
      <div className={[base, byTheme, hover, className].filter(Boolean).join(' ')}>
        {children}
      </div>
    </AnimatedGroup>
  );
}

ServiceCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  className: PropTypes.string,
  preset: PropTypes.oneOf([
    'fade', 'slide', 'scale', 'blur', 'blur-slide', 'zoom', 'flip', 'bounce', 'rotate', 'swing',
  ]),
  inViewOnce: PropTypes.bool,
  inViewAmount: PropTypes.number,
  rootMargin: PropTypes.string,
};

export default ServiceCard;
